import { render, staticRenderFns } from "./musicList.vue?vue&type=template&id=3df751c7&scoped=true"
import script from "./musicList.vue?vue&type=script&lang=js"
export * from "./musicList.vue?vue&type=script&lang=js"
import style0 from "./musicList.vue?vue&type=style&index=0&id=3df751c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df751c7",
  null
  
)

export default component.exports